import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  insightsLoadSuccess,
  insightsLoadFailure,
  insightsReloadSuccess,
  INSIGHTS_LOAD,
  INSIGHTS_RELOAD
} from './actions'

export function* insightsLoadSaga(action: any): Generator<any, void, any> {
  const { accountId, startDate, endDate } = action

  try {
    const params: any = {}
    if (startDate) {
      params.startDate = startDate
    }
    if (endDate) {
      params.endDate = endDate
    }

    const response = yield call(() =>
      axios.get(`/accounts/${accountId}/insights`, { params })
    )

    const insights = (response.data || []).map((item: any) => ({
      ...item,
      reportType: 'Executive Summary'
    }))

    yield put(insightsLoadSuccess(accountId, insights))
  } catch (error) {
    console.error('Insights load error:', error)
    yield put(insightsLoadFailure(accountId, error))
  }
}

export function* insightsReloadSaga(action: any): Generator<any, void, any> {
  const { accountId, startDate, endDate } = action

  try {
    const params: any = {}
    if (startDate) {
      params.startDate = startDate
    }
    if (endDate) {
      params.endDate = endDate
    }

    const response = yield call(() =>
      axios.get(`/accounts/${accountId}/insights`, { params })
    )

    const insights = (response.data || []).map((item: any) => ({
      ...item,
      reportType: 'Executive Summary'
    }))

    yield put(insightsReloadSuccess(accountId, insights))
  } catch (error) {
    console.error('Insights reload error:', error)
    // Silent fail on reload
  }
}

export function* watch(): Generator<any, void, any> {
  yield all([
    takeLatest(INSIGHTS_LOAD, insightsLoadSaga),
    takeLatest(INSIGHTS_RELOAD, insightsReloadSaga)
  ])
}
